// 教室api

import { baseRequest, fileRequest } from './base'

import store from '../vuex'

/**
 * @desc 查询教室列表
 */
function getClassroomList(params) {
  //如果选择了学校，加入学校字段
  if (store.getters.schoolId) {
    params = params ? params : {}
    params.schoolId = store.getters.schoolId
  }

  //清除空白字段
  params = utils.common.checkNull(params)
  let tempUrl = '/api/pcWeb/teaPlace/'
  return baseRequest(tempUrl, 'get', params)
}

/**
 * @desc 教室列表_all
 */
function getClassroomList_all(params) {
  //如果选择了学校，加入学校字段
  if (store.getters.schoolId) {
    params = params ? params : {}
    params.schoolId = store.getters.schoolId
  }
  //清除空白字段
  params = utils.common.checkNull(params)
  let tempUrl = '/api/pcWeb/teaPlace/list'
  return baseRequest(tempUrl, 'get', params)
}

/**
 * @desc 根据教室ID获取教室信息
 */
function getClassroomById(id) {
  return baseRequest(`/api/pcWeb/teaPlace/${id}`, 'get')
}

/**
 * @desc 新增教室
 */
function addClassroom(params) {
  //如果选择了学校，加入学校字段
  if (store.getters.schoolId) {
    params = params ? params : {}
    params.schoolId = store.getters.schoolId
  }

  return baseRequest(`/api/pcWeb/teaPlace/create`, 'post', params)
}

/**
 * @desc 删除教室
 */
function deleteClassroom(id) {
  return baseRequest(`/api/pcWeb/teaPlace/delete/${id}`, 'get')
}

/**
 * @desc 修改教室
 */
function updateClassroom(id, params) {
  return baseRequest(`/api/pcWeb/teaPlace/update/${id}`, 'post', params)
}

/**
 * @desc 下拉搜索教室
 */
function selectSearch(params) {
  //清除空白字段
  params = utils.common.checkNull(params)
  let tempUrl = '/api/pcWeb/teaPlace/selectSearch'
  return baseRequest(tempUrl, 'get', params)
}

/**
 * @desc 导入教室
 */
function importClassroom(params) {
  return fileRequest(`/api/pcWeb/teaPlace/import`, params)
}

/**
 * @desc 校验导入文件表头
 */
function checkHeader(params) {
  return fileRequest(`/api/pcWeb/teaPlace/checkHeader`, params)
}

/**
 * @desc 校验导入文件信息
 */
function checkFileInfo(params) {
  return fileRequest(`/api/pcWeb/teaPlace/checkFileInfo`, params)
}

/**
 * @desc 批量删除老师
 */
function batchDelete(params) {
  return baseRequest(`/api/pcWeb/teaPlace/batchDelete`, 'post', params)
}

/**
 * @desc 修改下拉搜索教室
 */
function listPlace(id) {
  return baseRequest(`/api/pcWeb/teaClass/listPlace/${id}`, 'get')
}

/**
 * @desc 新增下拉搜索教室
 */
function addListPlace(params) {
  return baseRequest(`api/pcWeb/teaPlace/list`, 'get', params)
}

/**
 * @desc 重置教室
 */
function resetPlace(params) {
  return baseRequest(`/api/pcWeb/teaClass/resetPlace`, 'post', params)
}

export default {
  getClassroomList: getClassroomList,
  getClassroomById: getClassroomById,
  addClassroom: addClassroom,
  deleteClassroom: deleteClassroom,
  updateClassroom: updateClassroom,
  getClassroomList_all: getClassroomList_all,
  selectSearch: selectSearch,
  importClassroom: importClassroom,
  checkHeader: checkHeader,
  checkFileInfo: checkFileInfo,
  batchDelete: batchDelete,
  listPlace,
  resetPlace,
  addListPlace,
}
